export const lightTheme = {
  name: 'light',

  primaryColor: '#D4B896',
  primaryDark: '#C4A77D',
  secondaryColor: '#E8DFCC',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#D4B896',

  bgPrimary: '#ffffff',
  bgSecondary: '#FFFCF8',
  bgTertiary: '#FFF8EE',

  background: '#FFF8EE',
  cardBackground: '#ffffff',
  hoverBackground: '#FFFAF4',

  textPrimary: '#3D2F1F',
  textSecondary: '#5C4A35',
  textMuted: '#7A6651',

  borderColor: '#E8DFCC',

  shadow:
    '0 1px 3px 0 rgba(212, 184, 150, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  shadowLg:
    '0 10px 25px -5px rgba(212, 184, 150, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',

  primaryHover: '#C4A77D', // --primary-hover
  primaryStrong: '#A08050', // --primary-strong (deep cream-tan, gradient endpoint)
  accentColor: '#8B7B6B', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(212, 184, 150, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(212, 184, 150, 0.4), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(212, 184, 150, 0.12)', // --shadow-soft

  primaryLight: 'rgba(212, 184, 150, 0.14)',
  unreadBackground: 'rgba(212, 184, 150, 0.06)',
  messageBubbleBg: '#FFFAF4',
  messageReceivedBg: '#ffffff',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
};

export const darkTheme = {
  name: 'dark',

  primaryColor: '#D4B896',
  primaryDark: '#C4A77D',
  secondaryColor: '#E8DFCC',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#E8DFCC',

  bgPrimary: '#1A150F',
  bgSecondary: '#2D2419',
  bgTertiary: '#3D2F1F',

  background: '#1A150F',
  cardBackground: '#2D2419',
  hoverBackground: '#3D2F1F',

  textPrimary: '#FFF8EE',
  textSecondary: '#E8DFCC',
  textMuted: '#C4B5A0',

  borderColor: '#5C4A35',

  shadow:
    '0 1px 3px 0 rgba(212, 184, 150, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.8)',
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(212, 184, 150, 0.35)',

  primaryHover: '#E8CCAA', // --primary-hover
  primaryStrong: '#F0D8B8', // --primary-strong (warm cream highlight, gradient endpoint)
  accentColor: '#C4B5A0', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(212, 184, 150, 0.3), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.9), 0 0 60px rgba(212, 184, 150, 0.35)', // --shadow-xl
  shadowSoft: 'rgba(212, 184, 150, 0.2)', // --shadow-soft

  primaryLight: 'rgba(212, 184, 150, 0.3)',
  unreadBackground: 'rgba(212, 184, 150, 0.16)',
  messageBubbleBg: '#3D2F1F',
  messageReceivedBg: '#4F3E2A',
  dangerLight: 'rgba(239, 68, 68, 0.25)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
